import { useLocalize } from 'localize-react';
import moment from 'moment';
import nunjucks from 'nunjucks';
import { useCallback } from 'react';

nunjucks.configure({})
  .addFilter('formatDate', (date: string, format: string) => {
    return moment(date).format(format);
  });

export const useRenderLocalizedTemplate = () => {
  const { translate, translations } = useLocalize();
  const renderLocalizedTemplate = useCallback(
    (template: string, data: Record<string, any>) => nunjucks.renderString(translate(template), data),
    [translations],
  );
  return { renderLocalizedTemplate };
};
